import { render, staticRenderFns } from "./etapa_5B.vue?vue&type=template&id=7c388581&scoped=true&"
import script from "./etapa_5B.vue?vue&type=script&lang=js&"
export * from "./etapa_5B.vue?vue&type=script&lang=js&"
import style0 from "./etapa_5B.vue?vue&type=style&index=0&id=7c388581&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c388581",
  null
  
)

export default component.exports